

// SHARED CLASSES FOR REPRESENTING COMPLIANCE MODELS

import { DateTime } from 'luxon';
import { toLuxonDateTime } from '@/js/filters-helpers';
import { nanoid } from 'nanoid';

// const COMPLIANCE_CATEGORIES_MAP = Object.fromEntries(COMPLIANCE_CATEGORIES.map(c => [c.value, c]));

// const BASE_KIND_NAMES_MAP = Object.fromEntries(BASE_KIND_NAMES.map(c => [c.value, c]));

class ComplianceItem {
    constructor(compItem) {
        // instantiate a new local object from the API data
        for (const key in compItem) {
            this[key] = compItem[key];
        }
        //const itemType = compItem.item_type || compItem.comp_item_type;  // field is 'comp_item_type' in DB
        // not sure we need this.... 
        // this.categoryLabel = itemType.category.label;
        // this.category = COMPLIANCE_CATEGORIES_MAP[itemType.category_name];  // no need... we get from backend
        // NO MORE EAS ON HERE - we combine the ones from CompItem and VendorCompItem in the VendorCompItemStatus object
        // this.hasExpireActionSpecs = Array.isArray(this.expire_action_specs) && this.expire_action_specs.length > 0;
    }
}

class ComplianceRequirement {
    constructor(compReq) {
        for (const key in compReq) {
            this[key] = compReq[key];
        }
    }
}

class VendorCompItem {
    constructor(vendorCompItem) {
        // instantiate a new local object from the API data
        for (const key in vendorCompItem) {
            this[key] = vendorCompItem[key];
        }
        // keep this here... we WILL add EAS to VendorCompItem
        // NO MORE EAS ON HERE - we combine the ones from CompItem and VendorCompItem in the VendorCompItemStatus object
        // this.hasExpireActionSpecs = Array.isArray(this.expire_action_specs) && this.expire_action_specs.length > 0;
    }
}


const NO_EXPIRATION_ISO_DATE = '9999-12-31T00:00:00Z';
const NO_EXPIRATION_MILLIS = DateTime.fromISO(NO_EXPIRATION_ISO_DATE).toMillis();


class SimpleComplianceSubmission {
    constructor(submission) {
        // instantiate a new local object from the API data
        // const { comp_item, ...subData } = submission;
        // this.compItem = new ComplianceItem(comp_item);

        // add all the other fields to the object
        for (const key in submission) {
            this[key] = submission[key];
        }
    }
}

// EXPIRE ACTION SPEC
// ---------------------------------------------------------------------------

// const EAS_PERIOD_OPTIONS = [
//     { value: 'days', label: 'Days' },
//     { value: 'weeks', label: 'Weeks' },
//     { value: 'months', label: 'Months' },
// ];


class ExpireActionSpec {
    constructor(expireActionSpec = {}) {
        // instantiate a new local object from the API data OR local data (when creating a new/empty one)
        // DO NOT SET DEFAULTS UNLESS YOU REALLLY NEED TO -- we set defaults in the Vue component when creating a new one
        this.id = expireActionSpec.id;
        this.title = expireActionSpec.title || '';
        this.content = expireActionSpec.content || '';
        // this.tenant_id = expireActionSpec.tenant_id;  // don't care about this on frontend
        this.comp_item_id = expireActionSpec.comp_item_id || null; // may be null if associated with a VendorCompItem instead
        this.vendor_comp_item_id = expireActionSpec.vendor_comp_item_id || null; // may be null if associated with a CompItem instead
        this.display_text = expireActionSpec.display_text || '';  // backend now computes this, replaces getText() method
        this.duration_days = expireActionSpec.duration_days || 0;
        this.duration_weeks = expireActionSpec.duration_weeks || 0;
        this.duration_months = expireActionSpec.duration_months || 0;
        this.is_active = expireActionSpec.is_active || false;  // if false, this EAS is inactive and should not be used
        this.last_validation_error = expireActionSpec.last_validation_error || '';  // if there was
        this.has_validation_error = !!(expireActionSpec.last_validation_error && expireActionSpec.last_validation_error.length);
        this.last_validation_at = expireActionSpec.last_validation_at ? toLuxonDateTime(expireActionSpec.last_validation_at) : null;
        // TODO? - this.computed_duration = expireActionSpec.computed_duration;
        this.duration_period = expireActionSpec.duration_period || 'weeks';  // days, weeks, months
        this.duration_num_periods = expireActionSpec.duration_num_periods || 0;  // number of periods
        this.action_type_value = expireActionSpec.action_type_value || '';  // REMINDER_TASK, SEND_EMAIL, etc. -- ALSO THE 'type_key' of the Configs
        this.schedule_type_value = expireActionSpec.schedule_type_value || '';  // BEFORE_SINGLE, AFTER_SINGLE, AFTER_RECUR
        this.event_type_value = expireActionSpec.event_type_value || '';  // DUE_DATE, EXPIRE_DATE
        this.recipient_type_value = expireActionSpec.recipient_type_value || '';  // VENDOR, INTERNAL, SPECIFIC_TU
        this.recipient_tu_id = expireActionSpec.recipient_tu_id || '';  // only if recipient_type_value is SPECIFIC_TU
        this.recipient_tu = expireActionSpec.recipient_tu || null;  // will have {id, full_name} if we have it
        this.recipient_object_role = expireActionSpec.recipient_object_role || null;  // will have {id, name} if we have it?
        this.recipient_object_role_id = expireActionSpec.recipient_object_role_id || null;  // will have ID if we have it
        // we also have a field 'custom_import_string' but we don't use it on frontend??? make sure backend doesn't remove it if we don't set it here
        this.recipient_emails = expireActionSpec.recipient_emails || [];  // array of email addresses (strings) to send to, for the SEND_EMAIL action type
        // LOCAL DATA - not from API
        this.localId = expireActionSpec.localId || this.id || nanoid();  // for tracking in the UI - must ALWAYS be set
        this.localEditMode = expireActionSpec.localEditMode || false;  // for tracking in the UI - must ALWAYS be set
        this._edits = {};  // stash data for editing - then set it back on the model when saving
    }
    // INSTANCE METHODS  -- NO LONGER NEED MOST OF THESE
    // startEdit() {
    //     // we don't set it in here... need Vue to set it so its reactive, right?
    //     // start editing this EAS - set localEditMode to true and make a copy of the current data
    //     const excludedKeys = ['localId', 'localEditMode', '_edits'];
    //     const dataCopy = {};
    //     for (const key in this) {
    //         if (!excludedKeys.includes(key)) {
    //             dataCopy[key] = this[key];
    //         }
    //     }
    //     // set the data to the copy
    //     this._edits = dataCopy;
    //     // set localEditMode to true
    //     this.localEditMode = true;
    // }
    // cancelEdit() {
    //     // cancel editing this EAS - set localEditMode to false and clear _edits
    //     this.localEditMode = false;
    //     this._edits = {};
    // }
    // getText() {
    //     return this.display_text;  // || this.getTextLocal();
    // }
    // getTextLocal() {  
    //     // REMOVE THIS ONCE BACKEND COMPUTES display_text
    //     // return a string with the text of the easData
    //     // this will be a computed property on the EAS model
    //     // const durationObj = {
    //     //     days: this.duration_days,
    //     //     weeks: this.duration_weeks,
    //     //     months: this.duration_months,
    //     // };
    //     // get from duration_period instead?  backend will include it...
    //     const actionString = EAS_ACTION_TYPE_OPTIONS.find(opt => opt.value === this.action_type_value)?.label || 'Unknown Action';
    //     const durationObj = {};
    //     durationObj[this.duration_period] = this.duration_num_periods;
    //     const luxonDuration = Duration.fromObject(durationObj);
    //     const durationString = luxonDurationToHumanizedString(luxonDuration);
    //     const beforeOrAfter = this.schedule_type_value === 'BEFORE_SINGLE' ? 'before' : 'after';
    //     const dueDateOrExpiration = this.event_type_value === 'DUE_DATE' ? 'due date' : 'expiration';
    //     const recipientText = this.recipient_tu?.full_name || 'recipient';
    //     const recipientObjectRoleText = this.recipient_object_role?.name ? `${this.recipient_object_role.name}` : '';
    //     let finalRecipientText = '';
    //     if (this.recipient_type_value === 'SPECIFIC_TU') {
    //         finalRecipientText = recipientText;
    //     } else if (this.recipient_type_value === 'COMP_ITEM_ROLE') {
    //         finalRecipientText = recipientObjectRoleText ? `Document Type ${recipientObjectRoleText}` : 'role';
    //     } else {
    //         finalRecipientText = this.recipient_type_value === 'VENDOR' ? 'vendor team' : 'internal team';
    //     }
    //     return `${actionString} to ${finalRecipientText} ${durationString} ${beforeOrAfter} ${dueDateOrExpiration}`;
    // }
    getDataForApi() {
        // return a plain object with the data to send to the API for updating/creating
        return {
            id: this.id,  // will be null for new EAS - backend will ignore it
            title: this.title,
            content: this.content,
            comp_item_id: this.comp_item_id,
            vendor_comp_item_id: this.vendor_comp_item_id,
            // duration_days: this.duration_days,
            // duration_weeks: this.duration_weeks,
            // duration_months: this.duration_months,
            duration_period: this.duration_period,  // we translate this into duration_days, duration_weeks, duration_months in backend
            duration_num_periods: this.duration_num_periods,
            type_key: this.action_type_value,  // backend expects 'type_key' instead of action_type_value -- needed to get the correct config
            is_active: this.is_active,  // we DO allow setting this from frontend
            action_type_value: this.action_type_value,
            schedule_type_value: this.schedule_type_value,
            event_type_value: this.event_type_value,
            recipient_type_value: this.recipient_type_value,
            recipient_tu_id: this.recipient_tu_id,
            recipient_object_role_id: this.recipient_object_role_id,
            recipient_emails: this.recipient_emails,
        };
    }
    isPersisted() {
        return !!this.id;
    }
    // STATIC PROPERTIES - we now get these from the backend, so no need to define them here
    // static get periodOptions() {
    //     return EAS_PERIOD_OPTIONS;
    // }
    // static get scheduleTypeOptions() {
    //     return EAS_SCHEDULE_TYPE_OPTIONS;
    // }
    // static get eventTypeOptions() {
    //     return EAS_EVENT_TYPE_OPTIONS;
    // }
    // static get recipientTypeOptions() {
    //     return EAS_RECIPIENT_TYPE_OPTIONS;
    // }
}


class VendorCompItemStatus {
    // pass in the VendorCompItemStatus object from the API (backend version!)
    // NOTE: this may not always have a vendor_comp_item!  It could be a CompItem/Vendor combo -- that's allowed in backend to show things not started yet for this vendor
    constructor(status) {
        this.id = status.id;  // NOT ALWAYS THE VCI ID!  status objects can also represent CompItem/Vendor combo, and for those the ID is different
        this.title = status.title;  // for new VCI version, we should always have title at top-level (correctly from CompItem or CompItemScope)
        this.vendor_id = status.vendor_id;
        this.vendor = status.vendor;
        // STATUS THINGS -- from the status object, which includes all the submissions, if any - should always have these things (but might be null)
        this.is_started = status.is_started;
        this.is_in_progress = status.is_in_progress;
        this.is_valid = status.is_valid;
        this.is_completed = status.is_completed;
        this.is_expired = status.is_expired;
        this.is_pending_supplier = status.is_pending_supplier;  // if the primary or secondary submission is in pending supplier state
        this.is_pending_internal_review = status.is_pending_internal_review;  // if the primary or secondary submission is in any after-submit internal review state
        this.valid_from = status.valid_from ? toLuxonDateTime(status.valid_from) : null;
        this.valid_to = status.valid_to ? toLuxonDateTime(status.valid_to) : null;
        // VALID FROM / TO DATES IN TENANT TIMEZONE (DATES ONLY) - we use the long attr names just to match backend
        // it is OK to use Luxon here even though we only have YYYY-MM-DD, Luxon adds time part (00:00:00) automatically, but we will not use it in our formatting here, so then its OK
        this.valid_from_date_tenant_tz = status.valid_from_date_tenant_tz ? toLuxonDateTime(status.valid_from_date_tenant_tz) : null;  // ONLY DATE in tenant TZ -- SHOW THIS ON FRONTEND
        this.valid_to_date_tenant_tz = status.valid_to_date_tenant_tz ? toLuxonDateTime(status.valid_to_date_tenant_tz) : null;  // ONLY DATE in tenant TZ -- SHOW THIS ON FRONTEND
        // FORMATTED STRINGS FOR DISPLAYING DATES -- use getters or a method for this???
        this.valid_from_date_formatted = this.valid_from_date_tenant_tz ? this.valid_from_date_tenant_tz.toLocaleString(DateTime.DATE_SHORT) : '';  // default to something falsey so we can show a default if needed 
        this.valid_to_date_formatted = this.valid_to_date_tenant_tz ? this.valid_to_date_tenant_tz.toLocaleString(DateTime.DATE_SHORT) : '';  // default to something falsey so we can show a default if needed
        // if (this.valid_from_date_tenant_tz) {
        //     console.log('VCI Status - valid_from_date_tenant_tz', `RAW: ${status.valid_from_date_tenant_tz}`, `LUXON: ${this.valid_from_date_tenant_tz.toString()}`);
        // }
        // if (this.valid_to_date_tenant_tz) {
        //     console.log('VCI Status - valid_to_date_tenant_tz', `RAW: ${status.valid_to_date_tenant_tz}`, `LUXON: ${this.valid_to_date_tenant_tz.toString()}`);
        // }
        // VALID FROM / TO DATETIMES AS TIMESTAMPS FOR SORTING (ONLY FOR SORTING!!! because we have defaults for no expiration)
        this.valid_from_timestamp = this.valid_from ? this.valid_from.toMillis() : 0;  // for sorting
        this.valid_to_timestamp = this.valid_to ? this.valid_to.toMillis() : NO_EXPIRATION_MILLIS;  // for sorting
        //this.validFromText = this.valid_from ? FormatDateHelper(this.valid_from) : '-';
        //this.validFromTimestamp = this.valid_from ? DateTime.fromISO(this.valid_from).toMillis() : 0;  // for sorting
        //this.expireText = this.valid_to ? FormatDateHelper(this.valid_to) : '-';
        //this.expireTimestamp = this.valid_to ? DateTime.fromISO(this.valid_to).toMillis() : NO_EXPIRATION_MILLIS;  // for sorting
        // VendorCompItem / CompItem / CompItemScope AND RELATED THINGS
        this.vendor_comp_item_id = status.vendor_comp_item_id;  // MAY BE NULL if not started/created yet (just a CompItem/vendor combo)
        this.vendor_comp_item = status.vendor_comp_item ? new VendorCompItem(status.vendor_comp_item) : null;
        this.vendorCompItem = this.vendor_comp_item;  // alias for now...... your consistency with casing sucks, bro....
        this.comp_item_scope_id = status.comp_item_scope_id;  // may be null, in many cases
        this.comp_item_id = status.comp_item_id;  // SHOULD ALWAYS HAVE THIS
        this.comp_item = status.comp_item ? new ComplianceItem(status.comp_item) : null;  // may not be included from serializer in backend.... but could be changed to always include
        this.compItem = this.comp_item;  // alias for now...... your consistency with casing sucks, bro....
        //this.compItemTitle = this.comp_item?.title || '';  // for new VCI version, title should be at top-level, either from CompItem or CompItemScope
        this.requirement = status.requirement ? new ComplianceRequirement(status.requirement) : null;  // nested requirement, if it has one - otherwise null
        this.hasRequirement = !!this.requirement;  // if it has a requirement
        // this.title = status.title || this.comp_item?.title || '';  // for new VCI version, title should be at top-level, either from CompItem or CompItemScope
        this.itemTypeId = status.comp_item_type_id;
        this.itemTypeName = status.comp_item_type_name; // this.comp_item.item_type.name; -- this is still OK to use, its basically the "folder" for CompItems now
        // this.category = status.comp_item_type_category; // TODO - remove this - nested { name, label, icon }
        // REPLACE category stuff with 'kind' stuff
        this.kind_id = status.kind_id;
        // TODO - do we need the full 'kind' object here?  maybe only certain fields... will get repetitive
        // you will also have it nested in this.comp_item.kind.... so not needed here?
        this.kind = status.kind;  // the full object... for now at least
        // EAS - on here, we only need to show that we have them... not the actual data (as of Dec 11 2024)
        this.hasExpireActionSpecs = status.expire_action_specs && Array.isArray(status.expire_action_specs) && status.expire_action_specs.length > 0;
        //this.compItemHasExpireActionSpecs = this.comp_item?.hasExpireActionSpecs || false;  // from the compItem
        //this.vendorCompItemHasExpireActionSpecs = this.vendor_comp_item?.hasExpireActionSpecs || false;  // from the vendorCompItem
        //this.hasExpireActionSpecs = this.compItemHasExpireActionSpecs || this.vendorCompItemHasExpireActionSpecs; 
        //this.fileCategory = 'comp_sub';   // still need this?  put on the submission instead?
        // SUBMISSIONS
        this.primary_submission_id = status.primary_submission_id;  // should always have
        this.secondary_submission_id = status.secondary_submission_id;  // should always have
        this.has_any_subs = status.has_any_subs;  // should always have

        // Submission Detail -- might not have these if not requested from backend
        const subs = status.submissions || [];
        this.submissions = subs.map(s => new SimpleComplianceSubmission(s));  // maybe were not included in backend
        
        const primarySub = this.submissions.find(s => s.id === this.primary_submission_id);
        // const secondarySub = this.submissions.find(s => s.id === this.secondary_submission_id);
        // submission stuff from primary submission
        // TODO - DEFINITELY move this logic to backend.... more consistent!
        // may not need it on frontend at all... clean this up
        // const primaryIsValid = primarySub?.is_valid;
        //this.statusText = primarySub?.sm_state ? primarySub.sm_state.toUpperCase() : '-';
        //this.subState = primarySub?.state || {};  // now on the API data directly - can just use 'state'
        //this.statePosition = this.subState?.position || 0;  // for sorting of states
        // might want to rename these to 'primarySubmissionFiles' or something
        // const fileIds = primaryIsValid && Array.isArray(primarySub?.files) ? primarySub.files.map(f => f.id) : [];
        // Changed June 30 2025 to show files for primary submission even if is NOT valid... kinda strange to hide them even if expired
        this.primarySubmissionFiles = Array.isArray(primarySub?.files) ? primarySub.files : [];  // FILES TO SHOW?  only show if primary is valid...
        this.overall_status = status.overall_status;  // NEW, backend version { key, label, description, variant }
    }
}

class CompReqStatus {  // intended to be 1:1 with backend
    constructor(req_status) {
        this.key = req_status.key;  // 'VALID', 'EXPIRED', etc.
        this.label = req_status.label;  // 'Valid', 'Expired', etc.
        this.label_combined = req_status.label_combined;  // combined label for overall status + need status, e.g. 'Required - Valid', etc.
        this.description = req_status.description;  // text description of the status
        this.category = req_status.category;  // { key: 'VALID', label: 'Valid', description: '' } - the overall status, but without the need status as part of it (VALID, INVALID, EXPIRED, MISSING, etc.)
        // this.need_status_key = req_status.need_status_key;  // 'MANDATORY', 'OPTIONAL', etc.  TRY TO REMOVE THIS - get from need_status_type
        this.need_status = req_status.need_status;  // the full nested need_status instance
        this.bsv_icon = req_status.bsv_icon;  // icon name for the status
        this.color = req_status.color;  // color for the status (the hex color, with leading #)
        this.variant = req_status.variant;  // 'success', 'warning', 'danger', etc.
        this.reason = req_status.reason;  // text explaining the status
    }
}

class CompanyNeedStatusResult {  // intended to be 1:1 with backend - holds info about WHY the status is what it is for a CompItem/Vendor/CompReq
    constructor(need_status_result) {
        this.company_id = need_status_result.company_id; 
        this.default_used = need_status_result.default_used;  // boolean
        this.override_used = need_status_result.override_used;  // ID of the override object, if it was used (string) or null
        this.rule_used = need_status_result.rule_used;  // ID of the rule object, if it was used (string) or null
        this.reason = need_status_result.reason;  // string - human-readable reason for the status
        this.need_status_type = need_status_result.need_status_type;  // { bsv_bg_variant, bsv_icon, bsv_icon_variant, can_set, description, key, label }
    }
}


class CompItemVendorStatus {
    constructor(apiObj) {
        // constructor that takes the API object
        this.id = apiObj.id;  // this is a COMPOSITE ID from comp_item_id and vendor_id: 'ci_v_status_123_456'
        this.comp_item_id = apiObj.comp_item_id;  // the comp_item_id from the API
        this.vendor_id = apiObj.vendor_id;  // the vendor_id from the API
        this.vendor_name = apiObj.vendor_name;  // the vendor_name from the API
        this.comp_item_type_id = apiObj.comp_item_type_id;  // the comp_item_type_id from the API
        this.req_id = apiObj.req_id;  // will be null if there is no CompReq for this CompItem
        this.title = apiObj.title;  // the title from the API
        this.vci_status_objects = apiObj.vci_status_objects && apiObj.vci_status_objects.length ? apiObj.vci_status_objects.map(vci => new VendorCompItemStatus(vci)) : [];  // map to the VendorCompItemStatus class
        this.req_status = apiObj.req_status ? new CompReqStatus(apiObj.req_status) : null;  // the req_status from the API
        this.need_status_result = apiObj.need_status_result ? new CompanyNeedStatusResult(apiObj.need_status_result) : null;  // the need_status_result from the API
        // some computed properties based on the need_status_result and other things
        this.overall_status_category_key = this.req_status?.category?.key || null;  // 'VALID', 'INVALID', 'EXPIRED', 'MISSING', etc.  this is the overall status category, without the need status as part of it
        this.need_status_key = this.need_status_result?.need_status_type?.key || null;  // 'MANDATORY', 'OPTIONAL', etc.  TRY TO REMOVE THIS - get from need_status_type
        this.has_override = !!this.need_status_result?.override_used;  // if there is an override used (which would be string? or nested object?), then we have an override
        this.has_vcis = Array.isArray(this.vci_status_objects) && this.vci_status_objects.length > 0;  // if we have any VCI status objects, then we have VCI status to show
    }
}


const MultiVciBehaviorOptions = {
    'any': {
        label: 'ANY Document Valid',
        description: 'At least one of the Documents for a vendor must be valid.',
    },
    'all': {
        label: 'ALL Documents Valid',
        description: 'All Documents for a vendor must be valid.',
    },
};




export {
    // COMPLIANCE_CATEGORIES,  // TODO - replace usage with KIND stuff
    // COMPLIANCE_CATEGORIES_MAP,  // TODO - replace usage with KIND stuff
    // BASE_KIND_NAMES,
    // BASE_KIND_NAMES_MAP,
    NO_EXPIRATION_ISO_DATE,
    NO_EXPIRATION_MILLIS,
    ComplianceItem,
    ComplianceRequirement,
    VendorCompItem,
    // ComplianceSubmission,
    ExpireActionSpec,
    VendorCompItemStatus,
    CompItemVendorStatus,
    MultiVciBehaviorOptions,
}